module.exports = __webpack_public_path__ + "img/fc-zenit-saint-petersburg.bfada600.png";